module onvio.common {
    'use strict';
    export class OnvioPrivacyFooterContentController {
        static $inject = ['$scope'];

        constructor(private $scope: ng.IScope) {
            angular.element(document).ready(function() {
                var links = document.getElementById('footer-links-container')?.children;
                if (links) {
                    (links[0] as HTMLElement).focus();
                    (links[0] as HTMLElement).addEventListener('keydown', (e) => {
                        if (e.code === "Tab" && e.shiftKey) {
                            e.preventDefault();
                            var close = document.getElementById('footer-links-close');
                            close.focus();
                        }
                    });
                }
            });
        }

        public Close() {
            this.$scope.$emit('close');
        }

        public HandletTab(e: KeyboardEvent) {
            if (e.code === "Tab" && !e.shiftKey) {
                var links = document.getElementById('footer-links-container')?.children;
                if (links) {
                    e.preventDefault();
                    (links[0] as HTMLElement).focus();
                }
            } else if (e.code === "Enter" || e.code === "Space") {
                this.Close();
            }
        }
    }

    export class OnvioPrivacyFooterContentComponent implements ng.IComponentOptions {
        controller = OnvioPrivacyFooterContentController;
        templateUrl = 'common/privacy-footer/privacy-footer-content.html';
    }

    angular.module('onvio.common.privacyFooterContent', [])
        .component('privacyFooterContent', new OnvioPrivacyFooterContentComponent());
}
